import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/geoState/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/geoState/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/geoState/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/geoState/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/geoState/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/geoState/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/geoState/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/geoState/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/geoState/UPDATE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loadedIds: [],
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadGeoStates(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/geo_states.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_STATE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadGeoState(geoState, options){
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.geoStates.loadedIds ? state.geoStates.loadedIds.slice() : []
    if (!loadedIds.includes(geoState.id)){
      loadedIds.push(geoState.id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/admin/geo_states/${geoState.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_STATE)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createGeoState(geoState, options, successCallback, errorCallback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      geo_state: geoState,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/geo_states.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_STATE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (successCallback) successCallback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        if (errorCallback) errorCallback(errors)
      })

    return promise
  }
}

export function updateGeoState(geoState, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      geo_state: geoState,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/geo_states/${geoState.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_STATE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
 ...state,
loading: true,
        loadedIds: action.loadedIds || state.loadedIds
  }
    case FETCH_SUCCESS:
      return {
 ...state,
loading: false,
        loaded: true,
        errors: [] 
 }
    case FETCH_FAILURE:
      return {
 ...state,
loading: false,
        loaded: false,
        errors: action.errors  
}
    case CREATE_REQUEST:
      return { ...state, creating: true  }
    case CREATE_SUCCESS:
      return {
 ...state,
creating: false,
        errors: [] 
 }
    case CREATE_FAILURE:
      return {
 ...state,
creating: false,
        errors: action.errors 
 }
    case UPDATE_REQUEST:
      return { ...state, updating: true  }
    case UPDATE_SUCCESS:
      return {
 ...state,
updating: false,
        errors: [] 
 }
    case UPDATE_FAILURE:
      return {
 ...state,
updating: false,
        errors: action.errors 
 }
    default:
      return state
  }
}
